import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { H3, H4 } from '../../../styles/FontStyles';
import { Flexed } from '../../../styles/GlobalComponents';

import { CaptionText, P1, P3 } from '../../../styles/FontStyles';

import moment from 'moment';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useAppSelector } from '../../../app/hooks';
import {
  CLUB,
  formatUSD,
  formatUSDNoDecimals
} from '../../../helpers/helperFunctions';

import { getOrders } from '../../../slices/orders-slice';
import { MyOrderListModel } from '../../Marketplace/Maeketplace.types';
import { CurrencyType } from '../../../types/types';
import Spinner from '../../../components/common/Spinner';
import { AnimatedDashboard } from '../../../components/animation/AnimatedDashboard';
import { SidebarModal } from '../../../components/common/Sidebar/Sidebar';
import WaitingForPaymentPackage from '../../Orders/WaitingForPaymentPackage';
import CancelPaymentPackage from '../../Orders/CancelPaymentPackage';
import { OrderType } from '../../Orders/Orders';
import { Desktop, Mobile } from '../../../App';
import {
  InvoiceHeader,
  Invoices,
  InvoicesMobile
} from '../../Orders/OrdersStyled';
import { AnimatedItem } from '../../../components/animation/AnimatedItem';
import { FlexBetween, HubLengthMessage } from '../../../styles/stylesStyled';
import { TextWithTooltip } from '../../../components/common/TextWithTooltip';
import { lightTheme } from '../../../styles/GlobalStyles';

export const OrdersSummary = () => {
  const [isSideModalOpen, setIsSideModalOpen] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] =
    useState<MyOrderListModel | null>(null);
  const { t } = useTranslation('packages');
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrders());
  }, [dispatch]);

  const { loading, orders } = useAppSelector((state) => state.orders);

  const orderStatus = (inv: MyOrderListModel) => {
    switch (inv.status) {
      case 1:
        return (
          <>
            <div style={{ marginTop: 4 }}>
              <span>
                <b
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setIsSideModalOpen(!isSideModalOpen);
                  }}>
                  {t('my_hubs_part.waiting')}
                </b>
              </span>
            </div>

            <div style={{ marginTop: 4 }}>
              {inv.type !== OrderType.LICENCE &&
                inv.currencyType !== CurrencyType.MIX &&
                inv.type !== OrderType.TRAVEL_SUBSCRIPTION && (
                  <span>
                    <b
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setIsCancelModalOpen(!isCancelModalOpen);
                      }}>
                      {t('my_hubs_part.cancel')}
                    </b>
                  </span>
                )}
            </div>
          </>
        );

      case 2:
        return <> {t('my_hubs_part.paid')}</>;
      case 3:
        return <>{t('my_hubs_part.canceled')}</>;
      case 4:
        return <>{t('my_hubs_part.canceled')}</>;
      default:
    }
  };

  if (loading && !orders) {
    return <Spinner fullScreen />;
  }

  return (
    <AnimatedDashboard zoom>
      <Desktop>
        <InvoiceHeader>
          <div style={{ width: '16.66%' }}>
            {t('my_hubs_part.date_created')}
          </div>
          <div style={{ width: '16.66%' }}>{t('my_hubs_part.date_paid')}</div>
          <div style={{ width: '16.66%' }}>{t('my_hubs_part.hub_name')}</div>
          <div style={{ width: '16.66%' }}>{t('my_hubs_part.order_id')}</div>
          <div style={{ width: '16.66%' }}>{t('my_hubs_part.value')}</div>
          <div
            style={{
              width: '16.66%',
              textAlign: 'right'
            }}>
            {t('my_hubs_part.status')}
          </div>
        </InvoiceHeader>
      </Desktop>
      {orders?.length === 0 ? (
        <HubLengthMessage
          // onClick={() => dispatch(setSelectedTab('hub'))}
          style={{ cursor: 'pointer' }}>
          {t('my_hubs_part.no_hubs')}
        </HubLengthMessage>
      ) : (
        orders?.map((inv: MyOrderListModel, i: number) => {
          return (
            <AnimatedItem key={i} index={i}>
              <Desktop>
                <Invoices>
                  <div style={{ width: '16.66%' }}>
                    {moment.utc(inv?.dateCreated).format('DD/MM/YY')}
                  </div>
                  <div style={{ width: '16.66%' }}>
                    {inv?.datePaid &&
                      moment.utc(inv?.datePaid).format('DD/MM/YY')}
                  </div>
                  <div style={{ width: '16.66%' }}>
                    {!inv?.name ? 'Free Trial Backoffice' : inv?.name}
                  </div>
                  <div style={{ width: '16.66%' }}>#{inv.orderId}</div>
                  <Flexed alignCenter style={{ width: '16.66%' }}>
                    <b>
                      <span>
                        {CurrencyType.MIX !== inv.currencyType &&
                          formatUSDNoDecimals(inv.price)}{' '}
                        {inv.currencyAmountToPay}
                      </span>
                    </b>
                    {CurrencyType.MIX === inv.currencyType && (
                      <TextWithTooltip
                        margin='0 0 0 10px'
                        width='auto'
                        tooltip={
                          <div>
                            {inv.payments.map((payment, i) => (
                              <CaptionText
                                color={lightTheme.colors.neutral500}
                                key={i}>
                                <span
                                  style={{
                                    width: 150,
                                    display: 'inline-block'
                                  }}>
                                  {payment.amount} {inv.currencyAmountToPay}
                                </span>
                                {moment(payment.dateCreated).format(
                                  'YYYY-MM-DD HH:mm:ss'
                                )}
                              </CaptionText>
                            ))}
                            {inv.amountToPay > 0 && (
                              <CaptionText
                                color={lightTheme.colors.neutral500}
                                key={i}>
                                <span
                                  style={{
                                    width: 150,
                                    display: 'inline-block'
                                  }}>
                                  {formatUSD(inv.amountToPay)}{' '}
                                  {inv.currencyAmountToPay}
                                </span>
                                <span
                                  style={{ color: lightTheme.colors.warning }}>
                                  PENDING
                                </span>
                              </CaptionText>
                            )}
                          </div>
                        }></TextWithTooltip>
                    )}
                  </Flexed>
                  <div
                    style={{
                      width: '16.66%',
                      textAlign: 'right'
                    }}
                    onClick={() => setSelectedPackage(inv)}>
                    {orderStatus(inv)}
                  </div>
                </Invoices>
              </Desktop>
              <Mobile>
                <InvoicesMobile style={{ cursor: 'pointer' }}>
                  <FlexBetween>
                    <div
                      style={{
                        fontWeight: 500,
                        lineHeight: '20px'
                      }}>
                      {!inv?.name ? (
                        'Free Trial Backoffice'
                      ) : (
                        <>
                          {inv.name.includes('+') ? (
                            <>
                              {inv.name.substring(0, inv.name.indexOf('+') - 1)}
                              <br />
                              {inv.name.substring(inv.name.indexOf('+') - 1)}
                            </>
                          ) : (
                            inv.name
                          )}
                        </>
                      )}
                    </div>
                    <div
                      style={{
                        fontWeight: 500,
                        lineHeight: '20px',
                        fontSize: 18
                      }}>
                      <Flexed alignCenter>
                        <b>
                          {formatUSDNoDecimals(inv?.price)}{' '}
                          {inv.currencyAmountToPay}
                        </b>
                        {CurrencyType.MIX === inv.currencyType && (
                          <TextWithTooltip
                            margin='0 0 0 10px'
                            width='auto'
                            tooltip={
                              <div>
                                {inv.payments.map((payment, i) => (
                                  <CaptionText
                                    color={lightTheme.colors.neutral500}
                                    key={i}>
                                    <span
                                      style={{
                                        width: 150,
                                        display: 'inline-block'
                                      }}>
                                      {payment.amount} {inv.currencyAmountToPay}
                                    </span>
                                    {moment(payment.dateCreated).format(
                                      'YYYY-MM-DD HH:mm:ss'
                                    )}
                                  </CaptionText>
                                ))}
                                {inv.amountToPay > 0 && (
                                  <CaptionText
                                    color={lightTheme.colors.neutral500}
                                    key={i}>
                                    <span
                                      style={{
                                        width: 150,
                                        display: 'inline-block'
                                      }}>
                                      {formatUSD(inv.amountToPay)} USDT (Tether){' '}
                                    </span>
                                    <span
                                      style={{
                                        color: lightTheme.colors.warning
                                      }}>
                                      PENDING
                                    </span>
                                  </CaptionText>
                                )}
                              </div>
                            }></TextWithTooltip>
                        )}
                      </Flexed>
                    </div>
                  </FlexBetween>
                  <FlexBetween>
                    <div>
                      {moment.utc(inv?.dateCreated).format('DD/MM/YY')}{' '}
                      <b style={{ marginLeft: '5px' }}>
                        <span>
                          {t('my_hubs_part.order_id')} {inv?.orderId}
                        </span>
                      </b>
                    </div>
                    <div
                      style={{
                        lineHeight: '18px',
                        fontSize: 12
                      }}
                      onClick={() => setSelectedPackage(inv)}>
                      {orderStatus(inv)}
                    </div>
                  </FlexBetween>
                </InvoicesMobile>
              </Mobile>
            </AnimatedItem>
          );
        })
      )}
      <SidebarModal
        isOpen={isSideModalOpen}
        setOpen={setIsSideModalOpen}
        title={t('my_hubs_part.payment_instructions_title')}
        sidebarWidth={'511px'}>
        <WaitingForPaymentPackage selectedPackage={selectedPackage} />
      </SidebarModal>

      <SidebarModal
        isOpen={isCancelModalOpen}
        setOpen={setIsCancelModalOpen}
        title={t('my_hubs_part.cancel_order_title')}
        sidebarWidth={'511px'}>
        <CancelPaymentPackage
          setIsCancelModalOpen={setIsCancelModalOpen}
          selectedPackage={selectedPackage}
        />
      </SidebarModal>
    </AnimatedDashboard>
  );
};
